import eventBus from '@/services/eventBus'
import { IUser } from '@/pages/Users/users.types.ts'

const created = (item: IUser) => {
  eventBus.pub('users.created', item)
}

const updated = (item: IUser) => {
  eventBus.pub('users.updated', item)
}

const deleted = (id: IUser['id']) => {
  eventBus.pub('users.deleted', id)
}

const usersEvents = { created, updated, deleted }
export default usersEvents
